module.exports = __webpack_public_path__ + "static/media/LongText.f444882e.svg";